export default class BaseStore {
    constructor(data) {
        this.data = data;
        this.subscribers = new Set();
    }
    /**
     * Возвращает текущее значение стора
     */
    get() {
        return this.data;
    }
    /**
     * Записывает новое значение стора
     */
    set(data) {
        if (this.data !== data) {
            this.data = data;
            this.subscribers.forEach(fn => fn(data));
        }
    }
    /**
     * Контракт для Svelte для работы со стором
     */
    subscribe(fn) {
        fn(this.data);
        this.subscribers.add(fn);
        return () => this.subscribers.delete(fn);
    }
    /**
     * Частичное обновление данных
     */
    update(data) {
        this.set(Object.assign(Object.assign({}, this.data), data));
    }
}
